import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';

import { switchMap } from 'rxjs/operators';
import { ApiConfiguration } from 'src/app/api/api-configuration';
import { StorageEnums } from 'src/shared/models/enums';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

	constructor(private storage: StorageService,
				private apiConfiguration: ApiConfiguration) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return from(Promise.all([
			this.storage.getItem(StorageEnums.AUTH_TOKEN),
			this.storage.getItem(StorageEnums.REFRESH_TOKEN),
			this.storage.getItem(StorageEnums.IsStage)
		])).pipe(
			switchMap(([auth, refresh, isStage]) => {

				let requestUrl = request.url;
				if (isStage === true || isStage === 'true') {
					requestUrl = requestUrl.replace('https://live', 'https://stage');
				}
				if (!requestUrl.startsWith(`${ this.apiConfiguration.rootUrl }`)) {
					return next.handle(request);
				}
				const customHeaders = {};


				const a = 'Authorization';

				if (!requestUrl.includes('identity/oauth2/userinfo')) {
					if (requestUrl.includes('auth/refresh') && refresh) {
						customHeaders[a] = `Bearer ${ refresh }`;
					} else if (auth) {
						customHeaders[a] = `Bearer ${ auth }`;
					}
					let params = { setHeaders: customHeaders };
					if (isStage === true || isStage === 'true') {
						const url = requestUrl.replace('https://live', 'https://stage');
						params = {
							...params, ...{
								url
							}
						};
					}
					request = request.clone(params);
				}
				return next.handle(request);
			})
		);
	}
}
